import React, { useEffect, useMemo } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { alpha } from "@mui/material/styles";
import { getTextDimensions } from "./stringutils";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import emojiRegex from "emoji-regex";
const useStyles = makeStyles((theme) => ({
    renderPart: {
        position: "absolute",
        boxSizing: "border-box",
    },
    selectText: {
        position: "absolute",
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        color: theme.palette.getContrastText(theme.palette.primary.light),
    },
    selectTextNum: {
        position: "absolute",
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        color: theme.palette.getContrastText(theme.palette.primary.light),
        backgroundColor: alpha(theme.palette.primary.light, 0.27),
        fontWeight: "bold",
        textAlign: "center",
    },
}));
const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
const emojiReplaceRegexp = emojiRegex();
const RenderString = React.memo((props) => {
    if (props.activeTextInputRef) {
        return React.createElement(RenderEditText, Object.assign({}, props));
    }
    return React.createElement(RenderText, Object.assign({}, props));
});
export default RenderString;
const RenderEditText = ({ renderPart, resource, activeTextInputRef, handleTextInputBlur, handleTextInputFocus, handleTextInputChange, scaleRatio, }) => {
    console.log("Render string", renderPart);
    const classes = useStyles();
    const theme = useTheme();
    const scaledRenderPart = useMemo(() => {
        return {
            width: renderPart.size.width * scaleRatio,
            height: renderPart.size.height * scaleRatio,
            x: renderPart.position.x * scaleRatio,
            y: renderPart.position.y * scaleRatio,
        };
    }, [renderPart, scaleRatio]);
    useEffect(() => {
        console.log("Edit text load");
        handleChange(null);
    }, [resource]);
    const horizontalAlign = (resource === null || resource === void 0 ? void 0 : resource.font.overrideHorizontalAlign) || renderPart.font.horizontalAlign;
    const verticalAlign = (resource === null || resource === void 0 ? void 0 : resource.font.overrideVerticalAlign) || renderPart.font.verticalAlign;
    const fontFamily = (resource === null || resource === void 0 ? void 0 : resource.font.overrideFamily) || renderPart.font.family;
    const color = (resource === null || resource === void 0 ? void 0 : resource.font.overrideColor) || renderPart.font.color;
    const fontSize = (resource === null || resource === void 0 ? void 0 : resource.font.overrideSize) || renderPart.font.size;
    const handleChange = (e) => {
        var _a, _b, _c;
        // Replace all emojis (emojiReplace has /g operator)
        let inputText = ((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ((resource === null || resource === void 0 ? void 0 : resource.font.text) || "")).replace(emojiReplaceRegexp, "");
        let text = inputText;
        if (renderPart.font.makeUppercase) {
            text = text.toUpperCase();
        }
        console.log("handleChange", (_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.value, text);
        const dim = getTextDimensions(fontFamily, text, fontSize, "pt", renderPart.size.width);
        let tooLarge = false;
        if (dim.width > renderPart.size.width ||
            dim.height > renderPart.size.height) {
            console.log("Too large", dim.width, renderPart.size.width, dim.height, renderPart.size.height);
            tooLarge = true;
        }
        if (e) {
            if (!tooLarge) {
                handleTextInputChange && handleTextInputChange(inputText);
            }
            else {
                e.preventDefault();
                console.log("Text is too long!");
            }
        }
        if (!tooLarge && (activeTextInputRef === null || activeTextInputRef === void 0 ? void 0 : activeTextInputRef.current)) {
            activeTextInputRef.current.style.height = dim.height + "px";
        }
        //setToLarge(tooLarge);
    };
    let textAlign = "left";
    switch (horizontalAlign) {
        case "center":
            textAlign = "center";
            break;
        case "right":
            textAlign = "right";
            break;
    }
    let align = "flex-start";
    switch (horizontalAlign) {
        case "center":
            align = "center";
            break;
        case "right":
            align = "flex-end";
            break;
    }
    let valign = "flex-start";
    switch (verticalAlign) {
        case "center":
            valign = "center";
            break;
        case "bottom":
            valign = "flex-end";
            break;
    }
    console.log("Vertical align", valign, verticalAlign);
    let rotate = 0;
    let rotateOriginX = 0;
    let rotateOriginY = 0;
    if (renderPart.transformations) {
        for (const transformation of renderPart.transformations) {
            if (transformation.type == "ROTATE") {
                rotate = transformation.rotate;
                rotateOriginY = Math.round(transformation.originY * scaleRatio);
                rotateOriginX = Math.round(transformation.originX * scaleRatio);
            }
        }
    }
    console.log("Render string__", renderPart, rotate, "jalla", "the end");
    const styles = {
        fontFamily: fontFamily,
        fontSize: fontSize + "pt",
        color: color,
        textAlign: textAlign,
        resize: "none",
        padding: 0,
        border: "none",
        width: "100%",
        overflowWrap: "normal",
        overflowX: "hidden",
        overflowY: "hidden",
        backgroundColor: "transparent",
        outline: "none",
    };
    if (renderPart.font.shadow) {
        const { offsetX, offsetY, opacity, blurRadius, color } = renderPart.font.shadow;
        styles.textShadow = `${offsetX}px ${offsetY}px ${blurRadius}px ${alpha(color, opacity / 100)}`;
    }
    const outerStyle = {
        position: "absolute",
        left: 0,
        top: 0,
        width: renderPart.size.width + "px",
        height: renderPart.size.height + "px",
        display: "flex",
        justifyContent: align,
        alignItems: valign,
        boxSizing: "border-box",
        transform: `scale(${scaleRatio})`,
        transformOrigin: "0 0 0",
    };
    const renderElement = {
        position: "absolute",
        left: scaledRenderPart.x + "px",
        top: scaledRenderPart.y + "px",
        width: scaledRenderPart.width + "px",
        height: scaledRenderPart.height + "px",
        transformOrigin: `${rotateOriginX}px ${rotateOriginY}px`,
        zIndex: 1000,
    };
    const overlayStyle = {
        position: "absolute",
        left: scaledRenderPart.x + "px",
        top: scaledRenderPart.y + "px",
        width: scaledRenderPart.width + "px",
        height: scaledRenderPart.height + "px",
        border: "1px solid " + theme.palette.primary.main,
        transformOrigin: `${rotateOriginX}px ${rotateOriginY}px`,
    };
    if (rotate) {
        renderElement.transform = `rotate(-${rotate}deg)`;
        overlayStyle.transform = `rotate(-${rotate}deg)`;
    }
    // If we "submit" the form (Remove keyboard), blur it. (Mobile)
    const handleSubmit = (e) => {
        e.preventDefault();
        // Let's do a blur hack:
        //   setDisabled(true);
        (activeTextInputRef === null || activeTextInputRef === void 0 ? void 0 : activeTextInputRef.current) && activeTextInputRef.current.blur();
    };
    let renderText = (resource === null || resource === void 0 ? void 0 : resource.font.text) || "";
    if (renderPart.font.makeUppercase) {
        renderText = renderText.toUpperCase();
    }
    return (React.createElement("form", { onSubmit: handleSubmit, method: "POST" },
        React.createElement("div", { style: overlayStyle }),
        React.createElement("div", { style: renderElement },
            React.createElement("div", { style: outerStyle, onClick: () => (activeTextInputRef === null || activeTextInputRef === void 0 ? void 0 : activeTextInputRef.current) && activeTextInputRef.current.focus() },
                React.createElement("textarea", { name: "thetext", style: styles, value: renderText, ref: activeTextInputRef !== null && activeTextInputRef !== void 0 ? activeTextInputRef : undefined, onBlur: handleTextInputBlur, onFocus: handleTextInputFocus, onChange: handleChange })))));
};
const RenderText = ({ renderPart, resource, monthStrings, year, handleUserStringClick, scaleRatio, mode, resourceNumber, }) => {
    var _a, _b;
    console.log("Render string", renderPart);
    const classes = useStyles();
    const theme = useTheme();
    const { t } = useTranslation();
    const scaledRenderPart = useMemo(() => {
        return {
            width: renderPart.size.width * scaleRatio,
            height: renderPart.size.height * scaleRatio,
            x: renderPart.position.x * scaleRatio,
            y: renderPart.position.y * scaleRatio,
        };
    }, [renderPart, scaleRatio]);
    const horizontalAlign = (resource === null || resource === void 0 ? void 0 : resource.font.overrideHorizontalAlign) || renderPart.font.horizontalAlign;
    const verticalAlign = (resource === null || resource === void 0 ? void 0 : resource.font.overrideVerticalAlign) || renderPart.font.verticalAlign;
    const fontFamily = (resource === null || resource === void 0 ? void 0 : resource.font.overrideFamily) || renderPart.font.family;
    const color = (resource === null || resource === void 0 ? void 0 : resource.font.overrideColor) || renderPart.font.color;
    const fontSize = (resource === null || resource === void 0 ? void 0 : resource.font.overrideSize) || renderPart.font.size;
    let textAlign = "left";
    switch (horizontalAlign) {
        case "center":
            textAlign = "center";
            break;
        case "right":
            textAlign = "right";
            break;
    }
    let valignItems = "flex-start";
    switch (verticalAlign) {
        case "center":
        case "middle":
            valignItems = "center";
            break;
        case "bottom":
            valignItems = "flex-end";
            break;
    }
    let rotate = 0;
    let rotateOriginX = 0;
    let rotateOriginY = 0;
    if (renderPart.transformations) {
        for (const transformation of renderPart.transformations) {
            if (transformation.type == "ROTATE") {
                rotate = transformation.rotate;
                rotateOriginY = Math.round(transformation.originY * scaleRatio);
                rotateOriginX = Math.round(transformation.originX * scaleRatio);
            }
        }
    }
    console.log("Render string__", renderPart, rotate, "the end");
    const renderElement = {
        position: "absolute",
        left: scaledRenderPart.x + "px",
        top: scaledRenderPart.y + "px",
        width: scaledRenderPart.width + "px",
        height: scaledRenderPart.height + "px",
        transformOrigin: `${rotateOriginX}px ${rotateOriginY}px`,
    };
    const outerStyle = {
        position: "absolute",
        width: renderPart.size.width + "px",
        height: renderPart.size.height + "px",
        top: 0,
        left: 0,
        display: "flex",
        alignItems: valignItems,
        textAlign: textAlign,
        lineHeight: "normal",
        transform: `scale(${scaleRatio})`,
        transformOrigin: "0 0 0",
    };
    if (renderPart.font.shadow) {
        const { offsetX, offsetY, opacity, blurRadius, color } = renderPart.font.shadow;
        outerStyle.textShadow = `${offsetX}px ${offsetY}px ${blurRadius}px ${alpha(color, opacity / 100)}`;
    }
    if (rotate) {
        renderElement.transform = `rotate(-${rotate}deg)`;
    }
    const innerStyles = {
        width: "100%",
        whiteSpace: "pre",
        fontFamily: fontFamily,
        fontSize: fontSize + "pt",
        color: color,
    };
    let text = "";
    let selectText = "";
    let re;
    if (renderPart.resourceId === "YEAR_STRING" && year) {
        text = String(year);
    }
    else if ((re = renderPart.resourceId.match(/MONTH\(([^(]+)\).+_STRING/))) {
        let monthNumber = 1;
        if (monthStrings[re[1]]) {
            monthNumber = monthStrings[re[1]].monthNumber;
        }
        if (renderPart.resourceId.match(/MONTH\(([^(]+)\)_YEAR_STRING/)) {
            text = t(monthNames[monthNumber - 1]) + " " + year;
        }
        else if (renderPart.resourceId.match(/MONTH\(([^(]+)\)_STRING/)) {
            text = t(monthNames[monthNumber - 1]);
        }
    }
    else if (resource === null || resource === void 0 ? void 0 : resource.userSupplied) {
        text = ((_b = (_a = resource.font) === null || _a === void 0 ? void 0 : _a.lines) === null || _b === void 0 ? void 0 : _b.join("\n")) || "";
        if (!text && handleUserStringClick && !(resource === null || resource === void 0 ? void 0 : resource.disableEdit)) {
            outerStyle.backgroundColor = theme.palette.primary.light;
            if (mode != "select-user-text") {
                selectText = t("Select text");
            }
        }
    }
    else {
        console.log("ERROR LOADING RESOURCE", renderPart, resource);
    }
    if (renderPart.font.makeUppercase) {
        text = text.toUpperCase();
    }
    return (React.createElement("div", { style: renderElement, className: "render-element" },
        React.createElement("div", { className: classes.renderPart, style: outerStyle },
            React.createElement("div", { style: innerStyles }, text)),
        selectText && React.createElement("div", { className: classes.selectText }, selectText),
        mode == "select-user-text" && (React.createElement("div", { className: classes.selectTextNum }, resourceNumber))));
};
